// extracted by mini-css-extract-plugin
module.exports = {"notification-icon":"notification-icon__3H0Y5","unread-badge":"unread-badge__2dGRx","nav-unread-badge":"nav-unread-badge__1Qy-l"};